<template>
    <div class="plan-change">
        <div class="container flex">
            <div class="change-button">
                <button
                    v-if="transition"
                    :class="[
                        'btn',
                        {
                            'is-green': transition === 'upgrade',
                        }
                    ]"
                    @click="handleClick"
                >
                    {{ capitalize(transition) }} to {{ plan.name }}
                </button>
            </div>
            <div
                v-if="price"
                class="price"
            >
                {{ usdFormatter(price, { withFraction: false }) }} <span class="faded">/mo</span>
            </div>
        </div>
    </div>
</template>

<script>
import { canDowngrade, canUpgrade } from '@/utils/plans';
import { capitalize } from 'lodash';
import { mapMutations, mapState } from 'vuex';
import { Step } from '@/utils/config/addShowModal';
import usdFormatter from '@/utils/usdFormatter';

export default {
    props: {
        plan: {
            type: [Object],
            required: true,
        },
        show: {
            type: [Boolean, Object],
            default: () => ({}),
        },
    },

    computed: {
        ...mapState({
            interval: (state) => state.userSubscription?.interval,
        }),

        /**
         * Checks if change button should display upgrade/downgrade
         *
         * @returns {string} return class name
         */
        transition() {
            return canUpgrade(this.show.plan, this.plan)
                ? 'upgrade'
                : canDowngrade(this.show.plan, this.plan)
                    ? 'downgrade'
                    : false;
        },

        /**
         * Gets plan minimal price.
         *
         * @returns {number|undefined} Price amount for current billing interval.
         */
        price() {
            return this.plan.prices?.[this.interval]?.monthlyAmount;
        },
    },

    methods: {
        capitalize,
        usdFormatter,

        ...mapMutations(['changeUIState']),

        /**
         * Handles transition button click.
         */
        handleClick() {
            this.changeUIState({
                addShowModal: {
                    mode: this.transition,
                    plan: this.plan,
                    show: this.show,
                    step: Step.Plans,
                    type: this.show.hosted ? 'hosted' : 'feed',
                    visible: true,
                },
            });
        },
    },
};
</script>
